import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

export function requestSuiteList(params) {
  const paramsObj = { limit: Number.MAX_SAFE_INTEGER };
  if (params && typeof params === "string") {
    params.split("&").forEach((pair) => {
      const [k, v] = pair.split("=");
      if (k && v) paramsObj[decodeURIComponent(k)] = decodeURIComponent(v);
    });
  }
  return fetch.get(`${BASE_URL}/api/app/suite`, { params: paramsObj });
}

export function requestCreateSuite(data) {
  return fetch.post(`${BASE_URL}/api/app/suite`, data);
}

export function requestUpdateSuite(data) {
  const { _id, ...body } = data;
  return fetch.put(`${BASE_URL}/api/app/suite/${_id}`, body);
}

export function requestDeleteSuite(data) {
  return fetch.delete(`${BASE_URL}/api/app/suite/${data._id}`);
}

export function requestSuiteById(id) {
  return fetch.get(`${BASE_URL}/api/app/suite/getById/${id}`);
}
